import { render, staticRenderFns } from "./Entete.vue?vue&type=template&id=2f3530d5&"
import script from "./Entete.vue?vue&type=script&lang=js&"
export * from "./Entete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports